var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"affiliates"},[_c('AffiliatesBanner'),_c('AffiliatesCode'),_c('AffiliatesStats'),_c('AffiliatesReferred')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }